/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2026 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

export const FIREFLY_PRO_OFFER_ID_DIRECT_TO_PAID =
  "5FEBA265B427FE3C8AD6FB1DFD078402";
export const FIREFLY_PRO_OFFER_ID_TRIAL_TO_PAID =
  "68C33F4BD35E1D1CD843BBD90D526D2A";
